import { render } from "./modalCantidades.vue?vue&type=template&id=c2e7c28e&scoped=true"
import script from "./modalCantidades.vue?vue&type=script&lang=js"
export * from "./modalCantidades.vue?vue&type=script&lang=js"

import "./modalCantidades.vue?vue&type=style&index=0&id=c2e7c28e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e7c28e"]])

export default __exports__